export function token(state = [], action) {
  switch (action.type) {
    case 'SAVED_ACCESS_TOKEN_SUCCESS':
      return action.token;
    default:
      return state;
  }
}
